import { createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';
import React, { Suspense, useEffect } from 'react';
import { Spin } from 'antd';

import { logoutAnyUser } from './redux/actions/activeUserActions';
import store from './redux/store/reduxStoreIndex';

import { createUseStyles, jss } from 'react-jss';
import jssPluginSyntaxGlobal from 'jss-plugin-global';
import routes from './routes';
import { useLiveQuery } from 'dexie-react-hooks';
import { getCookiedatabase } from './indexeddb/cookieIdb';

const useStyles = createUseStyles({
	fallbackSpin: {
		margin: 'auto',
		display: 'block',
		position: 'relative',
		top: '50%',
		transform: 'translateY(50%)',
		height: '100vh',
	},
	'@global': {
		body: {
			height: 'calc(100vh - 64px) !important',
			margin: '0px',
			'& .ant-card.ant-card-bordered': {
				border: '0px',
				boxShadow: '0px 20px 27px #0000000d',
				borderRadius: '8px',
				background: '#fff',
			},
			'& .ant-card-head-title': {
				fontSize: '20px',
				fontWeight: '600',
			},
			'& .ant-select-selection-search-input': {
				borderRadius: '4px',
			},
			'& .ant-btn': {
				boxShadow: '0 2px 4px rgb(0 0 0 / 7%)',
			},
			'& .ant-btn, .ant-radio-group .ant-radio-button-wrapper': {
				fontWeight: '600',
				fontSize: '12px',
			},
			'& .ant-typography': {
				margin: '0.5em 0',
			},
			'& .ant-notification-notice-message': {
				margin: 'auto 40px !important',
			},
		},
	},
});

const App = () => {
	jss.use(jssPluginSyntaxGlobal);
	const classes = useStyles();

	const token = useLiveQuery(async () => {
		const localToken = await getCookiedatabase().cookies.where('name').equals('token').first();
		if (localToken?.value) {
			return localToken?.value;
		}
		return null;
	}, []);

	useEffect(() => {
		if (token === null) {
			store.dispatch(logoutAnyUser());
		}
	}, [token]);

	const router = createBrowserRouter(createRoutesFromElements(routes), { basename: '/' });
	return (
		<Suspense fallback={<Spin className={classes.fallbackSpin} />}>
			<RouterProvider router={router} />
		</Suspense>
	);
};

export default App;

// function App() {
// 	return <div style={{ color: 'black', padding: '20px' }}>PA frontend is rendering</div>;
// }

// export default App;
